import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconUpArrow(props: SvgIconProps) {
  return (
    <SVGIcon width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 1H9V8" stroke="currentColor" strokeWidth={props?.strokeWidth ?? 2} />
      <path d="M9 1L1.22183 8.77817" stroke="currentColor" strokeWidth={props?.strokeWidth ?? 2} />
    </SVGIcon>
  );
}
